/**
 * Motion preference for this landing page.
 *
 * The page owner explicitly asked for the landing to always feel alive
 * (falling confetti, floating mockups, moving promo bar), so decorative
 * motion stays enabled. Everything animated here is slow, low-amplitude and
 * purely decorative: no flashing, no fast movement and no motion that blocks
 * reading. Returning `false` means "do not reduce motion".
 */
export function useGentleMotion(): boolean {
  return false
}
